module.exports = __webpack_public_path__ + "static/media/bhub.7e0e9302.png";